import {httpClient} from './httpClient';

const END_POINT = '/auth-token/';

const authenticate = (body = {}) => httpClient.post(END_POINT, body);

export {
    authenticate
}
